<template>
  <div class="mod-detail-button">
    <div class="mod-detail-button-inner">
      <div
        v-if="canCasualInterview"
        class="mod-button casual-interview-button js-over casual-interview-button-col pb4 pr3 pl3 pt7"
        data-test="casual-interview-button"
      >
        <div>
          <img
            :src="`${userEndPoint}/common/img/module/interview.png`"
            class="casual-interview-icon"
          >
          <span class="align-middle line-height-init">話を聞きたい</span>
        </div>
      </div>
      <a
        href="javascript:void(0);"
        class="mod-button search casual-interview-button-col entry-button"
        :class="[{'simple-btn':isSimpleTypeEntryFrom},{'light-btn':isLightTypeEntryForm}, {'non-casual-interview-button-col':!canCasualInterview}]"
        data-test="button"
      >
        <span
          v-if="isSimpleTypeEntryFrom"
          class="simpl-light-text"
          data-test="simple-text"
        >
          自己PR不要！<br>
        </span>
        <span
          v-if="isLightTypeEntryForm"
          class="simpl-light-text"
          data-test="light-text"
        >
          自己PRと職歴不要！<br>
        </span>
        <span>応募フォームへ</span>
      </a>
      <img
        :src="`${userEndPoint}/common/img/module/bookmark_star_off.png`"
        class="default-large book-mark js-over js-bm-btn is-inactive"
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'
export default {
  mixins: [jobPreviewVisibilityCommon],
  props: {
    entryFormType: {
      type: String,
      required: true
    },
    canCasualInterview: {
      type: Boolean,
      required: true
    }
  }
}
</script>
